import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [theme, setTheme] = useState(() => localStorage.getItem("cbk_theme") || "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("cbk_theme", theme);
  }, [theme]);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onLogout = () => setUser(false);
    window.addEventListener("cbk:logout", onLogout);
    return () => window.removeEventListener("cbk:logout", onLogout);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setToken(null);
      setUser(false);
    }
  }, []);

  return <AuthContext.Provider value={{ user, login, logout, theme, setTheme, toggleTheme: () => setTheme((t) => (t === "dark" ? "light" : "dark")) }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export const useCan = (roles) => {
  const { user } = useAuth();
  return !!user && roles.includes(user.role);
};
